import React, { useEffect, useState } from 'react'
import { useMutation } from '@apollo/client'
import { QRCodeSVG } from 'qrcode.react'
import Button from '../../components/atoms/Buttons'
import { CREATE_BOOKING_BALANCE_CHECKOUT, UPDATE_BOOKING } from '../../apollo/mutations/booking'
import './style.css'

const CollectBalanceModal = ({ booking, onClose, onDone }) => {
  const [url, setUrl] = useState('')
  const [errorText, setErrorText] = useState('')
  const [createCheckout, { loading }] = useMutation(CREATE_BOOKING_BALANCE_CHECKOUT)
  const [updateBooking, { loading: marking }] = useMutation(UPDATE_BOOKING, {
    refetchQueries: ['listBookingsByDate'],
  })

  // Generate the checkout session as soon as the modal opens.
  useEffect(() => {
    let cancelled = false
    ;(async () => {
      try {
        const { data } = await createCheckout({ variables: { id: booking.id } })
        if (!cancelled) setUrl(data?.createBookingBalanceCheckout || '')
      } catch (err) {
        if (!cancelled) setErrorText(err?.message || 'Could not start checkout.')
      }
    })()
    return () => {
      cancelled = true
    }
  }, [booking.id])

  // Auto-close once the polling parent picks up balancePaidAt.
  useEffect(() => {
    if (booking.balancePaidAt) {
      onDone?.()
    }
  }, [booking.balancePaidAt])

  const markPaid = async () => {
    if (!window.confirm('Mark this balance as paid manually? Use only if you collected cash or an external payment.')) return
    try {
      // No backend "manualPaid" mutation — mimic by stamping balancePaidAt via UPDATE_BOOKING.
      // Backend updateBooking ignores unknown fields, so we send a status no-op + status note.
      // Recommended path is the QR; this is the override only.
      alert('Manual mark-paid is not yet supported on the server. Please use the QR or invoice flow.')
    } catch (err) {
      setErrorText(err?.message || 'Could not mark paid.')
    }
  }

  const amount = booking.balanceDue ? `$${(booking.balanceDue / 100).toFixed(2)}` : '$0.00'

  return (
    <div>
      <div className="booking-modal-backdrop" onClick={onClose} />
      <div className="booking-modal-container" style={{ maxWidth: 460, width: '92%' }}>
        <h2 className="add-events !text-[24px] !mt-0 mb-1">Collect Balance</h2>
        <p className="text-[12px] font-montserrat text-[color:var(--color-gray-text)] mb-1">
          {booking.customerName}
        </p>
        <div className="text-[32px] font-bold text-[color:var(--color-primary)] mb-4">{amount}</div>

        {loading && !url && (
          <div className="text-[13px] text-[color:var(--color-gray-text)] mb-4">Generating secure payment link…</div>
        )}
        {errorText && <div className="text-[13px] text-[color:var(--color-primary-danger)] mb-3">{errorText}</div>}

        {url && (
          <>
            <div className="bg-white p-4 rounded-[12px] inline-block border border-[#EAEBED]">
              <QRCodeSVG value={url} size={260} level="M" />
            </div>
            <p className="text-[12px] font-montserrat text-[color:var(--color-gray-text)] mt-3">
              Have the customer scan this with their phone camera. Apple Pay, Google Pay, or any card works.
            </p>
            <p className="text-[11px] text-[color:var(--color-secondary)] underline break-all mt-2">
              <a href={url} target="_blank" rel="noreferrer">{url}</a>
            </p>
          </>
        )}

        <div className="flex gap-x-3 justify-center mt-5">
          <Button type="button" onClick={onClose} primaryOutline>
            Close
          </Button>
        </div>
      </div>
    </div>
  )
}

export default CollectBalanceModal
